module.exports = ({ url, progress = () => {} }) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'arraybuffer';
    xhr.onprogress = ({ loaded, total }) => {
      isNaN(total) ?
        progress({ loaded }) :
        progress({ loaded, total });
    };
    xhr.onloadend = () => {
      xhr.status == 200 ?
        resolve(xhr.response) :
        reject({
          error: xhr.statusText,
          status: xhr.status
        });
    };
    xhr.send();
  });
};
